import { render, staticRenderFns } from "./company-phones.vue?vue&type=template&id=7c2386b2&"
import script from "./company-phones.vue?vue&type=script&lang=js&"
export * from "./company-phones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports